import React from 'react';
import {DiplomatObjectType} from 'types/DiplomatObjectType';
import RecoverKeysDialog from './RecoverKeysDialog';

type Props = {
   onClose: () => void;
};

const PUBLIC_KEY_PROPS = {objectType: DiplomatObjectType.enum.PUBLIC_KEY};
export const RecoverOpenPgpPublicKeysDialog = ({onClose}: Props) => {
   return <RecoverKeysDialog data={PUBLIC_KEY_PROPS} onClose={onClose} />;
};

const KEY_PAIRS_PROPS = {objectType: DiplomatObjectType.enum.KEY_PAIR};
export const RecoverOpenPgpKeyPairsDialog = ({onClose}: Props) => {
   return <RecoverKeysDialog data={KEY_PAIRS_PROPS} onClose={onClose} />;
};
